import { render, staticRenderFns } from "./ListHeader.vue?vue&type=template&id=7048c221&scoped=true"
import script from "./ListHeader.vue?vue&type=script&lang=ts"
export * from "./ListHeader.vue?vue&type=script&lang=ts"
import style0 from "./ListHeader.vue?vue&type=style&index=0&id=7048c221&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7048c221",
  null
  
)

export default component.exports